import React from 'react'
import { Redirect } from 'react-router-dom'
import { decode } from './Store'

let Auth = ({ location }) => <Redirect to={decode(new URLSearchParams(location.search).get('forward_path'))} />

export default Auth
